import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { Layout } from "../components/Layout";
import { ArrowRight, EnvelopeSimple, Lock } from "@phosphor-icons/react";
import { toast, Toaster } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      toast.success(`${t("welcome_back")}, ${u.name}`);
      const roleHomes = { admin: "/admin", sponsor: "/sponsor/dashboard" };
      const target = loc.state?.from?.pathname || roleHomes[u.role] || "/dashboard";
      nav(target, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("error_occurred"));
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <Toaster richColors position="top-center" />
      <div className="max-w-md mx-auto px-6 py-12">
        <Link to="/" className="inline-block mb-6" aria-label="MYTHIVA home">
          <img src="/mythiva-logo.png" alt="MYTHIVA™" className="h-9 w-auto object-contain" draggable="false" />
        </Link>
        <h1 className="text-3xl font-bold text-[var(--as-primary)]" style={{fontFamily:"Inter"}}>{t("login")}</h1>
        <p className="mt-2 text-[var(--as-text-secondary)]">{t("welcome_back")} to MYTHIVA<span className="align-super text-[0.55em]">™</span> · Associate Skill.</p>

        <form className="as-card p-7 mt-8 space-y-5" onSubmit={submit} data-testid="login-form">
          <div>
            <label className="as-label">{t("email")}</label>
            <div className="relative">
              <EnvelopeSimple size={18} weight="duotone" className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--as-text-secondary)]" />
              <input
                value={email} onChange={(e) => setEmail(e.target.value)}
                type="email" required
                className="as-input !pl-10" placeholder="you@example.com" data-testid="login-email"
              />
            </div>
          </div>
          <div>
            <label className="as-label">{t("password")}</label>
            <div className="relative">
              <Lock size={18} weight="duotone" className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--as-text-secondary)]" />
              <input
                value={password} onChange={(e) => setPassword(e.target.value)}
                type="password" required
                className="as-input !pl-10" placeholder="••••••••" data-testid="login-password"
              />
            </div>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
            {busy ? "..." : t("login")} <ArrowRight size={18} weight="bold" />
          </button>
          <div className="text-center text-sm text-[var(--as-text-secondary)]">
            New here? <Link to="/register" className="font-bold text-[var(--as-accent)]" data-testid="link-to-register">{t("sign_up")}</Link>
          </div>
        </form>
      </div>
    </Layout>
  );
}
